export const enSE = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "We're here to help you",
  description:
    "Do you have any questions for Lassie? Contact us via chat, email or phone for help with your insurance.",
  mainEntity: {
    "@type": "Organization",
    name: "Lassie AB",
    url: "https://www.lassie.co",
    logo: "https://www.lassie.co/images/logo-with-name.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Döbelnsgatan 21",
      addressLocality: "Stockholm",
      postalCode: "111 40",
      addressCountry: "SE",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "hej@lassie.se",
        telephone: "+46-10-183-98-18",
        availableLanguage: ["English", "Swedish"],
        areaServed: "SE",
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
          opens: "08:00",
          closes: "21:00",
        },
      },
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "skadeteamet@lassie.co",
        telephone: "+46-10-183-98-18",
        availableLanguage: ["English", "Swedish"],
        areaServed: "SE",
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "09:00",
          closes: "12:00",
        },
      },
      {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "direktreglering@lassie.co",
        telephone: "+46-10-183-98-18",
        availableLanguage: ["English", "Swedish"],
        areaServed: "SE",
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "08:00",
          closes: "17:00",
        },
      },
      {
        "@type": "ContactPoint",
        contactType: "complaints",
        email: "klagomal@lassie.co",
        availableLanguage: ["English", "Swedish"],
        areaServed: "SE",
      },
    ],
  },
};
